import Hashids from 'hashids';

export default {
  methods: {
    isStaging() {
      return /^https\:\/\/test-flower-score/.test(location.href);
    },
    isProduction() {
      return /^https\:\/\/taoyuan-flower-score/.test(location.href);
    },
    getAccessToken() {
      const queryString = location.search;
      const params = new URLSearchParams(queryString);
      const token = params.get('token') || null;
      return token;
    },
    getHash() {
      const outputHashids = new Hashids('X5lM3VPyBvm', 32, '0123456789abcdef');
      /* Use a virtual account */
      return outputHashids.encode([5566001, Date.now()]);
    },
    imageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    getResizedImageBlob(file, minSize = 400) {
      const newImage = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      let newWidth = 0;
      let newHeight = 0;

      return new Promise((resolve) => {
        newImage.onload = () => {
          const { width, height } = newImage;
          if (width > height) {
            const rate = minSize / width;
            newHeight = rate * height;
            newWidth = minSize;
          } else {
            const rate = minSize / height;
            newWidth = rate * width;
            newHeight = minSize;
          }
          canvas.width = newWidth;
          canvas.height = newHeight;

          ctx.drawImage(newImage, 0, 0, newWidth, newHeight);

          canvas.toBlob((blob) => {
            resolve(blob);
          }, 'image/jpeg');
        };
        newImage.src = URL.createObjectURL(file);
      });
    },
    taoyuanExpertHost() {
      if (this.isStaging()) {
        return `https://test-taoyuan-expert.webduino.tw`;
      }
      if (this.isProduction()) {
        return `https://taoyuan-expert.webduino.tw`;
      }
      return `http://localhost:3000`;
    },
    async getFileFromUrl(url, name, defaultType = 'image/jpg'){
      const response = await fetch(url);
      const data = await response.blob();
      return new File([data], name, {
        type: response.headers.get('content-type') || defaultType,
      });
    },
  },
};
